import { mixpanel } from '@fiverr-private/obs';
import { BriefCreationVariant } from '../context/BriefCreationContext';

const completeEventData = (options: { [key: string]: string | boolean | number } = {}) => ({
    ...options,
    source: options.source ? options.source : window.location.pathname,
});

export const dmBriefCreationDrawerOpen = () => {
    mixpanel.track('dm brief creation drawer open', completeEventData());
};

export const dmBriefCreationDrawerGenerateClick = () => {
    mixpanel.track('dm brief creation drawer generate click', completeEventData());
};

export const dmBriefCreationDrawerCreateClick = () => {
    mixpanel.track('dm brief creation drawer create click', completeEventData());
};

type EventStatus = 'Click' | 'Failed' | 'Success';

export const seamless = (variant: BriefCreationVariant) => {
    const eventData = completeEventData({
        source: variant === 'onboarding_routing' ? 'standalone' : variant,
        url: window.location.pathname,
    });

    const withEventData = (extra?: { [key: string]: string | boolean | number }) => ({
        ...eventData,
        ...(extra || {}),
    });

    const generateBrief = {
        show: () => mixpanel.track('Job Post - Generate Brief - Show', eventData),
        close: () => mixpanel.track('Job Post - Generate Brief - Close', eventData),
        submit: (status: EventStatus) => mixpanel.track(`Job Post - Generate Brief - Submit - ${status}`, eventData),
        inputFocus: () => mixpanel.track('Job Post - Generate Brief - Input - Focus', eventData),
        tagClick: (tagTitle: string) =>
            mixpanel.track('Job Post - Generate Brief - Tag - Click', withEventData({ tagTitle })),
    };

    const editBrief = {
        show: (extra?: { [key: string]: string | boolean | number }) =>
            mixpanel.track('Job Post - Brief Editor - Show', withEventData(extra)),
        close: () => mixpanel.track('Job Post - Brief Editor - Close', eventData),
        success: (extra?: { [key: string]: string | boolean | number }) =>
            mixpanel.track('Job Post - Edit Brief - Success', withEventData(extra)),
        inviteFreelancers: (status: EventStatus) =>
            mixpanel.track(`Job Post - Brief Editor - Invite Freelancers - ${status}`, eventData),
        sourceForMe: (status: EventStatus) =>
            mixpanel.track(`Job Post - Brief Editor - Source For Me - ${status}`, eventData),
    };

    const duplicateBrief = {
        success: () => mixpanel.track('Job Post - Duplicate Brief - Success', eventData),
    };

    return { generateBrief, editBrief, duplicateBrief };
};
